import { createReducer, on } from '@ngrx/store';

import { BoardLayoutInspectionTemplatesUsage, RestBoardModel } from '@main-application/boards/interfaces/board';
import {
  getTemplatesUsage,
  getTemplatesUsageFailed,
  getTemplatesUsageSuccess,
  loadBoardList,
  loadBoardListFailed,
  loadBoardListSuccess,
  loadBoardSummaryDetails,
  loadBoardSummaryDetailsFailed,
  loadBoardSummaryDetailsSuccess,
  loadBoardSummaryStats,
  loadBoardSummaryStatsFailed,
  loadBoardSummaryStatsSuccess,
  updateTemplateUsage,
  updateTemplateUsageFailed,
  updateTemplateUsageSuccess,
} from '@main-application/boards/store/boards.actions';
import {
  BoardsSummaryStatsDetails,
  SummaryStatsGroup,
} from '@ui-components/components/summary-expandable-table/summary-expandable-table.model';

export const boardsFeatureKey = 'boardsState';

export interface State {
  updateTemplateUsageStatus: any;
  boardsLoading: boolean;
  boards: RestBoardModel[];
  templatesUsage: BoardLayoutInspectionTemplatesUsage[];
  boardSummaryStats: SummaryStatsGroup[] | null;
  boardSummaryDetails: BoardsSummaryStatsDetails | null;
  boardSummaryLoading: boolean;
  boardSummaryError: any;
}

export const initialState: State = {
  boardsLoading: false,
  boards: [],
  updateTemplateUsageStatus: 'idle',
  templatesUsage: [],
  boardSummaryStats: null,
  boardSummaryDetails: null,
  boardSummaryLoading: false,
  boardSummaryError: null,
};

export const reducer = createReducer(
  initialState,
  on(loadBoardList, (state, action) => ({ ...state, boardsLoading: true })),
  on(loadBoardListSuccess, (state, action) => ({ ...state, boards: action.boards, boardsLoading: false })),
  on(loadBoardListFailed, (state, action) => ({ ...state, boardsLoading: false })),
  on(updateTemplateUsage, state => ({ ...state, updateTemplateUsageStatus: 'loading' })),
  on(updateTemplateUsageSuccess, state => ({ ...state, updateTemplateUsageStatus: 'success' })),
  on(updateTemplateUsageFailed, state => ({ ...state, updateTemplateUsageStatus: 'failure' })),
  on(getTemplatesUsage, state => ({ ...state, templatesUsageLoading: true, templatesUsageError: null })),
  on(getTemplatesUsageSuccess, (state, { templatesUsage }) => ({
    ...state,
    templatesUsageLoading: false,
    templatesUsage,
  })),
  on(getTemplatesUsageFailed, (state, { error }) => ({
    ...state,
    templatesUsageLoading: false,
    templatesUsageError: error,
  })),
  on(loadBoardSummaryStats, state => ({ ...state, boardSummaryLoading: true, boardSummaryError: null })),
  on(loadBoardSummaryStatsSuccess, (state, { stats }) => ({
    ...state,
    boardSummaryStats: stats,
    boardSummaryLoading: false,
  })),
  on(loadBoardSummaryStatsFailed, (state, { error }) => ({
    ...state,
    boardSummaryLoading: false,
    boardSummaryError: error,
  })),
  on(loadBoardSummaryDetails, state => ({ ...state, boardSummaryLoading: true, boardSummaryError: null })),
  on(loadBoardSummaryDetailsSuccess, (state, { details }) => ({
    ...state,
    boardSummaryDetails: details,
    boardSummaryLoading: false,
  })),
  on(loadBoardSummaryDetailsFailed, (state, { error }) => ({
    ...state,
    boardSummaryLoading: false,
    boardSummaryError: error,
  }))
);
